import { render } from "./Rules.vue?vue&type=template&id=01b1de40&scoped=true"
const script = {}

import "./Rules.vue?vue&type=style&index=0&id=01b1de40&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shawn\\sloppy-golf\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b1de40"]])

export default __exports__